"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickableAreaStyled = exports.SwirlStyled = exports.Center = exports.InnerSwirl = exports.OuterSwirl = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hotspot = require("../../hotspot.constants");

var _hotspotGlobal = require("../../hotspot.global.styles");

var _hotspot2 = _interopRequireDefault(require("../../hotspot.styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var spin = (0, _styledComponents.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var spin2 = (0, _styledComponents.keyframes)(["from{transform:rotate(360deg);}to{transform:rotate(0deg);}"]);
var svgStyles = "\n  overflow: visible;\n  stroke-dasharray: 150;\n  stroke-linecap: round;\n  transition: stroke-dasharray 300ms ease;\n";

var OuterSwirl = _styledComponents.default.svg.attrs({
  focusable: false
}).withConfig({
  displayName: "Swirlstyles__OuterSwirl",
  componentId: "sc-17iy49t-0"
})(["", " animation-duration:1.5s;animation-iteration-count:infinite;animation-name:", ";animation-timing-function:linear;height:100%;transform:translate(-50%,-50%);width:100%;"], svgStyles, spin);

exports.OuterSwirl = OuterSwirl;

var InnerSwirl = _styledComponents.default.svg.attrs({
  focusable: false
}).withConfig({
  displayName: "Swirlstyles__InnerSwirl",
  componentId: "sc-17iy49t-1"
})(["", " animation-duration:1.3s;animation-iteration-count:infinite;animation-name:", ";animation-timing-function:linear;height:75%;left:12.5%;position:absolute;top:12.5%;width:75%;"], svgStyles, spin2);

exports.InnerSwirl = InnerSwirl;

var Center = _styledComponents.default.div.withConfig({
  displayName: "Swirlstyles__Center",
  componentId: "sc-17iy49t-2"
})(["border-radius:50%;height:54%;left:50%;opacity:0;position:absolute;top:50%;transform:", ";transition:opacity 0.3s ease;width:54%;"], _hotspotGlobal.translateXY);

exports.Center = Center;

var svgStylesOnHover = function svgStylesOnHover(secondaryColor) {
  return "\n  animation-play-state: paused;\n  path {\n      stroke: ".concat(secondaryColor, ";\n  };\n  stroke-dasharray: 400;\n");
}; // $FlowFixMe


var SwirlStyled = _styledComponents.default.div.attrs(function (_ref) {
  var iconPosition = _ref.iconPosition;
  return {
    style: {
      left: "".concat(iconPosition.left, "%"),
      top: "".concat(iconPosition.top, "%")
    }
  };
}).withConfig({
  displayName: "Swirlstyles__SwirlStyled",
  componentId: "sc-17iy49t-3"
})(["position:absolute;height:10em;width:10em;display:flex;align-items:center;justify-content:center;transform:", ";"], _hotspotGlobal.translateXY);

exports.SwirlStyled = SwirlStyled;

var hoverState = function hoverState(secondaryColor) {
  return "\n  ".concat(InnerSwirl, " {\n    ").concat(svgStylesOnHover(secondaryColor), "\n  };\n  ").concat(OuterSwirl, " {\n    ").concat(svgStylesOnHover(secondaryColor), "\n  };\n\n  ").concat(Center, " {\n    background: ").concat(secondaryColor, ";\n    opacity: 1;\n  }\n");
};

var ClickableAreaStyled = (0, _styledComponents.default)(_hotspot2.default).withConfig({
  displayName: "Swirlstyles__ClickableAreaStyled",
  componentId: "sc-17iy49t-4"
})(["", ""], function (_ref2) {
  var disableHover = _ref2.disableHover;
  return !disableHover && (0, _styledComponents.css)(["&:hover,&", "{", ";}", ""], _hotspot.focusVisible, function (_ref3) {
    var secondaryColor = _ref3.secondaryColor;
    return hoverState(secondaryColor);
  }, function (_ref4) {
    var secondaryColor = _ref4.secondaryColor,
        previewHoverState = _ref4.previewHoverState;
    return previewHoverState && hoverState(secondaryColor);
  });
});
exports.ClickableAreaStyled = ClickableAreaStyled;